import axios from 'axios'; 

import ISubscribeTaskListRequest from '../types/tasks/ISubscribeTaskListRequest'
import apiSettings from '../config/apiSettings';
import graphSettings from '../config/graphSettings';
import { getAuthorizationHeader } from '../utils/auth';

export default {
	getTaskLists: (accessToken: string) => axios.get(`${graphSettings.baseUrl}/me/todo/lists`, { headers: getAuthorizationHeader(accessToken) }),
	getTaskSubscriptions: (accessToken: string) => axios.get(`${graphSettings.baseUrl}/subscriptions`, { headers: getAuthorizationHeader(accessToken), }),

	getTaskListsViaApi: (id: string, accessToken: string) => axios.get(apiSettings.baseUrl + '/api/GetTaskLists', { params: { id: id }, headers: getAuthorizationHeader(accessToken) }),
	subscribeTaskListViaApi: (model: ISubscribeTaskListRequest, accessToken: string) => axios.post(apiSettings.baseUrl + '/api/SetupTaskList', model, { headers: getAuthorizationHeader(accessToken) }),
}
